import { gql } from '@apollo/client';

export const GET_ORGANIZATION = gql`
  query organization($organizationId: String!) {
    get(organizationId: $organizationId)
      @rest(
        type: "Organization"
        path: "/organizations/{args.organizationId}"
        endpoint: "admin"
      ) {
      admins
      organization
      organizationBinderId
      usesOrganizationRoles
      platform
      customer {
        id
        name
      }
    }
  }
`;

export const GET_ORGANIZATION_SUMMARY = gql`
  query organizationSummary($organizationId: String!) {
    organizationSummary(organizationId: $organizationId)
      @rest(
        type: "Binder"
        path: "/support/summary/{args.organizationId}"
        endpoint: "documents"
      ) {
      documentsCount
      documentVersionsCount
      deletedDocumentsCount
      deletedVersionsCount
      totalSizeInBytes
      totalDeletedSizeInBytes
    }
  }
`;

export const UPDATE_ORG_THRESHOLDS = gql`
  mutation updateOrganizationThresholds($id: String!, $body: Object!) {
    updateThresholds(id: $id, body: $body)
      @rest(
        type: "Organization"
        path: "/organizations/settings/resourcethreshold/{args.id}"
        method: "PUT"
        endpoint: "organizations"
        bodyKey: "body"
      ) {
      FacilityThreshold
      ProjectThreshold
      TenderThreshold
    }
  }
`;

export const UPDATE_ORG_TERMINATION_PERIODS = gql`
  mutation updateOrganizationTerminationPeriods($id: String!, $body: Object!) {
    updateTerminationPeriods(id: $id, body: $body)
      @rest(
        type: "OrganizationSetting"
        path: "/organizations/settings/binderterminationperiod/{args.id}"
        method: "PUT"
        endpoint: "organizations"
        bodyKey: "body"
      ) {
      key
      value
    }
  }
`;

export const GET_ORG_SETTINGS = gql`
  query orgSettings {
    settings
      @rest(
        type: "OrganizationSetting"
        path: "/organizations/settings"
        endpoint: "organizations"
      ) {
      key
      value
    }
  }
`;

export const UPDATE_ORGANIZATION_CUSTOMER = gql`
  mutation updateOrganizationCustomer($id: String!, $body: Object!) {
    updateCustomer(id: $id, body: $body)
      @rest(
        type: "Organization"
        path: "/organizations/company/{args.id}"
        method: "PUT"
        endpoint: "organizations"
        bodyKey: "body"
      ) {
      customer {
        id
        name
      }
    }
  }
`;
